import {searchModel} from "../../Utilities/Search";
import {isNullOrUndefined} from "../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../Utilities/Sort";

export const librarySearchModel = (userId = "", systemType = "", barCode = "", includeInactive = false) => {
    return Object.assign({}, searchModel(userId.toString(), "itemName", false, "itemName"), {
        systemType,
        barCode,
        includeInactive,
        ClearOrderSearch: clearOrderSearch,
        ApplySorting: applySorting,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.systemType = "";
    this.barCode = "";
    this.includeInactive = false;
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(librarySearchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(librarySearchCriteria.sortByColumn as string, librarySearchCriteria.sortDescending as boolean));
}

